<template>
  <v-layout>
    <v-flex xs6 offset-xs3 sm4 offset-sm4>
      <v-card class="elevation-12">
        <v-card-text>
          <v-form>
            <h2 class="headline mb-0 text-md-center">Clube Beneficios</h2>
            <h3 class="headline mb-0 text-md-center">Registrar-se</h3>
            <v-text-field
              label="E-mail"
              v-model="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              type="password"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              required
            ></v-text-field>
          </v-form>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="text-transform-none" @click="submit">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Signin',
  mixins: [validationMixin],
  data () {
    return {
      title: 'Signin',
      email: '',
      password: ''
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      await this.$store.dispatch('signUserUp', {email: this.email, password: this.password})
      //await this.$router.push('/')
    },
    clear () {
      this.$v.$reset()
      this.email = ''
      this.password = ''
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/hello')
      }
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      return errors
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-transform-none {
    text-transform: none;
  }
</style>


// WEBPACK FOOTER //
// src/pages/user/Signup.vue